/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototyperToggleModel
 */
export interface PrototyperToggleModel {
    /**
     * 
     * @type {string}
     * @memberof PrototyperToggleModel
     */
    auth_id: string;
}

/**
 * Check if a given object implements the PrototyperToggleModel interface.
 */
export function instanceOfPrototyperToggleModel(value: object): value is PrototyperToggleModel {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    return true;
}

export function PrototyperToggleModelFromJSON(json: any): PrototyperToggleModel {
    return PrototyperToggleModelFromJSONTyped(json, false);
}

export function PrototyperToggleModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototyperToggleModel {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
    };
}

export function PrototyperToggleModelToJSON(json: any): PrototyperToggleModel {
    return PrototyperToggleModelToJSONTyped(json, false);
}

export function PrototyperToggleModelToJSONTyped(value?: PrototyperToggleModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
    };
}

